import { sessionStartedAt } from '../../lib/wearSessions'
import { gymTemperature } from '../../lib/gymQuickWear'
import FragranceImage from '../collection/FragranceImage'

function ShareIcon() {
  return <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 15V3m0 0L8 7m4-4 4 4" />
    <path d="M5 11v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8" />
  </svg>
}

export default function GymWearSummary({ wear, onEdit, onOpen, onShare }) {
  if(!wear?.log)return null
  const {log,fragrance}=wear, temperature=gymTemperature(log)
  const name=fragrance?.name||log.fragrance_name||'Gym scent'
  return <section aria-label="Saved gym wear" className="my-3 flex items-center gap-2 rounded-xl border border-sage/25 bg-charcoal-800 p-2">
    <button type="button" disabled={!fragrance} onClick={()=>onOpen(fragrance)} aria-label={`Open details for ${name}`} className="group flex min-h-16 min-w-0 flex-1 items-center gap-3 rounded-lg p-1 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/70 disabled:cursor-default">
      <span className="w-14 shrink-0"><FragranceImage fragrance={fragrance || {name,house:log.house,card_image:log.card_image}} /></span>
      <span className="min-w-0 flex-1">
        <span className="block text-[10px] font-semibold text-sage">Gym scent</span>
        <span className="block truncate text-sm font-semibold text-cream group-hover:text-gold">{name}</span>
        <span className="block truncate text-xs text-cream/55">{new Date(sessionStartedAt(log)).toLocaleTimeString('en-US',{hour:'numeric',minute:'2-digit'})}{log.sprays != null?` · ${log.sprays} sprays`:''}{temperature?` · ${temperature}`:''}</span>
      </span>
    </button>
    <div className="flex shrink-0 flex-col items-center">
      <button type="button" className="flex min-h-11 min-w-11 items-center justify-center rounded-lg text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/70" onClick={()=>onShare(fragrance)} disabled={!fragrance} aria-label={`Share ${name}`}><ShareIcon /></button>
      <button type="button" className="min-h-11 rounded-lg px-2 text-xs text-cream/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/70" onClick={()=>onEdit(log)}>Edit</button>
    </div>
  </section>
}
